export default __webpack_public_path__ + "bfdc2046f04210cb84ecb07f2982a081.png";